<template>
  <div
    class="form__checkbox-wrapper">
    <input
      :id="id"
      :name="label"
      type="checkbox"
      class="form__checkbox"
      @change="$emit('checked', field, label, $event.target.checked)"
    >
    <label
      :for="id"
      class="form__option-label"
    ><span 
      :style="{ color: checkboxColor }" 
      class="form__option-input form__option-input--checkbox"/>{{ label }}</label>
  </div>
</template>

<script>
// The checkbox and check colors should match the button background
export default {
  name: "FieldCheckbox",
  props: {
    checkboxColor: {
      type: String,
      default: "rgb(34,158,61)" // default to the mockup green
    },
    field: {
      type: Object,
      required: true
    },
    id: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
@import "ConvoStyles/convo_master.scss"; // Allows us to use scss variables

input[type="checkbox"] {
  &:checked ~ label > .form__option-input--checkbox:before {
    content: "";
    height: 6px;
    border-left: 2px solid currentColor;
    border-bottom: 2px solid currentColor;
    border-bottom-left-radius: 1px;
    border-color: currentColor;
    transform: rotate(-48deg);
    left: 4px;
    position: absolute;
    top: 5px;
    width: 11px;
  }
}
.form__option-input {
  border-radius: 2px;
}
</style>
